<template>
  <div class="order-list c:col-start-stretch">
    <CEmpty v-if="list.length == 0 && !loading" text="暂无订单" />
    <div class="filter-bar c:row-between-center">
      <CSearchBar
        v-model="keyword"
        placeholder="搜索订单编号或客人昵称"
        @search="onSearch"
        @clear="onClear"
      />
      <div class="filter-btn" @click="isFilterShown = !isFilterShown">
        <img
          v-if="filtered"
          class="filter-icon"
          src="@/assets/icons/order-filter-active.svg"
          alt=""
        />
        <img
          v-else
          class="filter-icon"
          src="@/assets/icons/order-filter-inactive.svg"
          alt=""
        />
      </div>
    </div>
    <div class="sorter-bar c:row-start-center">
      <CSortSwitch
        label="下单时间"
        value="CREATE_TIME"
        :active="sort === 'CREATE_TIME'"
        @change="onSortChange"
      />
      <CSortSwitch
        label="销售金额"
        value="AMOUNT"
        :active="sort === 'AMOUNT'"
        @change="onSortChange"
      />
    </div>
    <OrderFilterPopop
      v-model="isFilterShown"
      :z-index="900"
      :is-multiple-salers="$store.getters.isStoreManagerAccount"
      @filter="onFilter"
    />
    <div class="order-list-wrapper">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="load"
      >
        <order-list-cell
          :data="item"
          v-for="(item, index) in list"
          :key="index"
        />
      </van-list>
      <CBottomPad is-tab-page />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CEmpty from "@/components/common/Empty.vue";
import CSearchBar from "@/components/common/SearchBar.vue";
import OrderFilterPopop from "./OrderFilterPopop.vue";
import OrderListCell from "./OrderListCell.vue";
import { getOrderList } from "@/api";
import CSortSwitch from "../common/SortSwitch.vue";
import CBottomPad from "../common/CBottomPad.vue";

export default {
  components: {
    CEmpty,
    CSearchBar,
    OrderFilterPopop,
    CSortSwitch,
    OrderListCell,
    CBottomPad,
  },
  props: { role: String },
  data() {
    return {
      isFilterShown: false,

      loading: false,
      finished: false,
      refreshing: false,
      finishedText: "",
      page: 1,
      keyword: "",
      filters: {},
      sort: undefined, // 'CREATE_TIME' | 'AMOUNT' | undefined
      asc: undefined,
      list: [],
    };
  },

  computed: {
    ...mapState(["user"]),
    filtered() {
      // console.log("filters", Object.keys(this.filters));
      return Object.entries(this.filters).some(([key, value]) => {
        console.log("filter", key, value);
        if (key.endsWith("List")) {
          return !!value?.length;
        } else if (key.endsWith("Time")) {
          return !!value;
        }
        return false;
      });
    },
  },
  methods: {
    async load() {
      console.log("loading");

      try {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        const res = await getOrderList({
          ...this.filters,
          keyword: this.keyword,
          pageNum: this.page || 1,
          sort: this.sort,
          asc: this.sort ? this.asc || false : undefined,
          pageSize: 10,
        });
        console.log("getOrderList", res);
        res.data?.forEach((element) => {
          this.list.push(element);
        });
        this.page++;
        this.loading = false;
        if (res.hasMore) {
          this.finished = false;
        } else {
          this.finished = true;
          this.finishedText = this.list.length > 0 ? "已加载全部订单" : "";
        }
      } catch (error) {
        this.loading = false;
        this.finished = true;
        this.finishedText = this.list.length > 0 ? "加载订单出错" : "";
        if (error?.message) this.$toast(error.message);
      }
    },
    reload() {
      this.loading = true;
      this.finished = false;
      this.refreshing = true;
      this.page = 1;
      this.load();
    },
    onSearch() {
      // console.error("onSearch", this.keyword);
      this.reload();
    },
    onClear() {
      // console.error("onClear", this.keyword);
      this.reload();
    },
    onFilter(filters) {
      // console.log("onFilter", filters);
      this.filters = filters;
      this.reload();
    },
    onSortChange(sort) {
      console.log("onSortChange", sort);
      Object.assign(this, sort);
      this.reload();
    },
  },
};
</script>
<style lang="less">
.order-list {
  --filter-bar-height: 3rem;
}
</style>
<style lang="less" scoped>
.order-list {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;

  user-select: none;

  .filter-bar {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: var(--filter-bar-height);
    padding: 10/20rem 20/20rem;
    border-top: solid 2/20rem #f2f2f2;
    border-bottom: solid 2/20rem #e4e4e4;
    background: #ffffff;
    z-index: 999;

    .filter-btn {
      width: 36/20rem;
      height: 36/20rem;
      padding: 7/20rem 0/20rem 7/20rem 14/20rem;

      .filter-icon {
        width: 22/20rem;
        height: 22/20rem;
      }
    }
  }

  .sorter-bar {
    gap: 14/20rem;

    box-sizing: border-box;
    width: 100%;
    height: 46/20rem;
    padding: 0 16/20rem;

    border-bottom: solid 1/20rem #e4e4e4;
    background-color: #ffffff;
  }

  .order-list-wrapper {
    flex: 1;
    box-sizing: border-box;
    width: 100%;
    // height: 0;
    padding-top: 4/20rem;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 0;
  }
}
</style>
